import { Outlet } from 'react-router-dom'

import Loading from 'modules/finance/components/Loading'
import CollectionsBootstrap from 'modules/finance/lib/Financial_workspaceCollectionsBootstrap'

import { useFinancialWorkspacePage } from './useFinancialWorkspacePage'

const RootPage = () => {
  const {
    canSeeFinanceWorkspace,
    canSeeFinanceWorkspacePayroll,
    canAccessOverview,
    canSeeAllCompanyData,
    canSeeFinanceWorkspaceCompensations,
    seePayrollLanding,
    loading,
    error,
  } = useFinancialWorkspacePage()

  if (error) {
    return null
  }

  return (
    <CollectionsBootstrap>
      <Loading loading={loading}>
        <Outlet
          context={{
            canSeeFinanceWorkspace,
            canSeeFinanceWorkspacePayroll,
            canAccessOverview,
            canSeeAllCompanyData,
            canSeeFinanceWorkspaceCompensations,
            seePayrollLanding,
          }}
        />
      </Loading>
    </CollectionsBootstrap>
  )
}

export default RootPage
